import { bootstrapApplication } from "@angular/platform-browser";
import { AppComponent } from "@app/app.component";
import {
    provideAppInitializer,
    inject,
    ErrorHandler,
    provideZonelessChangeDetection,
    provideEnvironmentInitializer,
} from "@angular/core";
import { provideAnimationsAsync } from "@angular/platform-browser/animations/async";
import { provideRouter, withComponentInputBinding, withViewTransitions } from "@angular/router";
import { AppConfigService } from "@api/services/app-config.service";
import { AppErrorHandler } from "@api/services/app-error-handler.service";
import { provideOAuthClient } from "angular-oauth2-oidc";
import { MessageService, ConfirmationService } from "primeng/api";
import { providePrimeNG } from "primeng/config";
import { AzaraPreset, GlobalPassThroughs } from "src/assets/layout/styles/azara-preset";
import { routes } from "@app/app-routes";
import { provideHttpClient, withInterceptorsFromDi } from "@angular/common/http";
import { DialogService } from "primeng/dynamicdialog";
import { provideCustomInterceptors } from "@api/interceptors";
import { AppInsightsService } from "@api/services/app-insights/app-insights.service";
import { AuthService } from "@auth/services/auth/auth.service";
import { InactivityService } from "@auth/services/inactive-timeout.service";

bootstrapApplication(AppComponent, {
    providers: [
        MessageService,
        ConfirmationService,
        DialogService,
        provideZonelessChangeDetection(),
        provideAnimationsAsync(),
        provideCustomInterceptors(),
        provideHttpClient(withInterceptorsFromDi()),
        provideOAuthClient(),
        provideRouter(routes, withViewTransitions(), withComponentInputBinding()),
        providePrimeNG({
            theme: {
                preset: AzaraPreset,
                options: {
                    darkModeSelector: false,
                    cssLayer: {
                        name: "primeng",
                        order: "theme, base, primeng",
                    },
                },
            },
            pt: GlobalPassThroughs,
        }),
        provideAppInitializer(async () => {
            const appConfigService = inject(AppConfigService);
            const authService = inject(AuthService);

            await appConfigService.initialize();
            authService.initialize();
        }),
        provideEnvironmentInitializer(() => {
            inject(InactivityService);
            const appInsightsService = inject(AppInsightsService);

            appInsightsService.initialize();
        }),
        { provide: ErrorHandler, useClass: AppErrorHandler },
    ],
}).catch((err) => console.error(err));
